<template>
  <div class="email-confirmation">
    <img src="../assets/logo-with-label.svg" alt="Meetch logo" class="logo-with-label">
    <div>
      <img :src="mainImage" alt="Email confirmed" class="email" />
      <div class="thank-you">
        <h1>{{ header }}</h1>
        <p>{{ text }}</p>
      </div>
      <img src="../assets/envelopes.svg" alt="Emails" class="envelopes" />
    </div>
    <div class="gray-footer">
      <p>Copyright (c) Meetch - Helsinki, Finland</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmailConfirmation',
  props: {
    success: {
      deault: true,
      type: Boolean,
      required: true,
    },
  },
  computed: {
    mainImage() {
      if (this.success) return require('../assets/email-confirmed.svg');
      return require('../assets/email-failed.svg');
    },
    header() {
      if (this.success) return 'All good!';
      return 'Oops!';
    },
    text() {
      if (this.success) return 'Thank you for confirming your email! You can now go back to the app';
      return 'Unfortunately, your email verification link did not work. You can request a new confirmation link in the app.';
    },
  },
};
</script>

<style lang='scss' scoped>
@use '@/styles/variables' as *;
@use '@/styles/breakpoints' as *;

  .email-confirmation {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .email {
    width: 300px;
    padding-bottom: 2em;

    @include breakpoint(medium) {
      width: 500px;
    }

    @include breakpoint(large) {
      width: auto;
    }
  }

  .logo-with-label {
    margin: 2em auto;
    padding: 2em 0;
  }

  .thank-you {
    padding: 2em;
  }

  .envelopes {
    max-width: 100%;
  }

  .gray-footer {
    background-color: $myTypeLightGray;
    min-height: 100px;
    padding-top: 2em;
    color: $myTypeMediumGray;
  }
</style>
